import React, { useState, useEffect } from 'react';
import { makeStyles, Theme, createStyles, Typography, IconButton, Modal, ButtonBase, Divider } from '@material-ui/core';
import { Edit as EditIcon, Save as SaveIcon, Cancel as CancelIcon } from '@material-ui/icons'
import CharacterCreate from './CharacterCreate'
import Character from '../../Character/Character'
import SpriteManager, { SpriteDefine } from '../../Character/SpriteManager'
import { OnelineText, IconUpload, StatusText, RatingField } from './InputSupport'
import AvatarUpload from './AvatarUpload';
import { useTranslation } from "react-i18next"

import  * as Lambda from "../../../Lambda";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            height: "100%",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
        },
        container: {

        },
        buttons: {
            marginTop: theme.spacing(1),
            display: "flex"
        },
        space: {
            flexGrow: 1
        },
        content: {
            height: 0,
            flexGrow: 1,
            overflowY: "scroll",
        },
        item: {
            margin: theme.spacing(1)
        },
        media: {
            marginRight: theme.spacing(2),
            height: 0,
            paddingTop: '56.25%', // 16:9
        },
        star: {
            color: "#e69500"
        }
    }),
);


const PopupContent = React.forwardRef<HTMLDivElement,React.HTMLAttributes<HTMLDivElement>>((props,ref)=>(
    <div {...props} ref={ref} />
))

interface Props {
    globalSetting?: Lambda.GetMyInfoResponseType | undefined
}

function MyInfo(props: Props) {

    const classes = useStyles()
    const [t] = useTranslation()

    const [editable, setEditable] = useState(false)
    const [popup, setPopup] = useState(false)
    const [popupAvatar, setPopupAvatar] = useState(false)

    const [blob, setBlob] = React.useState<Blob|undefined>()
    const [myInfo, setMyInfo] = React.useState<Lambda.GetMyInfoResponseType|undefined>(props.globalSetting)
    const [myInfoState, setMyInfoState] = React.useState<Lambda.GetMyInfoResponseType|undefined>()
    
    const [spriteManager, setSpriteManager] = React.useState<SpriteDefine | undefined>();

    // init
    useEffect(()=>{
        const func = async () => {
            setMyInfo(await Lambda.getMyInfo({}))
        }
        func()
    },[])

    return (

        <div className={classes.root}>
            <SpriteManager ready={(sm)=>setSpriteManager(sm)} />
                { !editable ? 
                    <div className={classes.buttons}>
                        <div className={classes.space}></div>
                        <IconButton  
                            color="primary"
                            onClick={()=>{
                                setMyInfoState(JSON.parse(JSON.stringify(myInfo)))
                                setBlob(undefined)
                                setEditable(true)
                            }}
                        >
                            <EditIcon/>
                        </IconButton >
                    </div> :
                    <div className={classes.buttons}>
                        <div className={classes.space}></div>
                        <IconButton  
                            color="primary"
                            onClick={async ()=>{
                                if (myInfo) {
                                    setMyInfo(await Lambda.setMyInfo(myInfo))
                                    console.log(myInfo)
                                    if (myInfo.icon.set && blob) {
                                        fetch(myInfo.icon.set, {method: "put",body: blob})
                                    }
                                } 
                                setBlob(undefined)
                                setEditable(false)
                            }}
                        >
                            <SaveIcon/>
                        </IconButton >
                        <IconButton  
                            color="secondary"
                            onClick={()=>{
                                setMyInfo(JSON.parse(JSON.stringify(myInfoState)))
                                setBlob(undefined)
                                setEditable(false)
                            }}
                        >
                            <CancelIcon/>
                        </IconButton >
                    </div>
                }

            <Divider />
            
            { myInfo ? 
                <div className={classes.content}>
                    <Typography>{t("message.myInfo.globalSetting")}</Typography>
                    <div className={classes.item}>
                        <OnelineText 
                            label={t("label.character.handle")}
                            value={myInfo.name}
                            onChange={(v)=>{setMyInfo({...myInfo, name:v})}}
                            editable={editable} />
                    </div>
                    <div className={classes.item}>
                        <IconUpload 
                            label={t("label.character.icon")}
                            value={myInfo.icon.get}
                            onChange={()=>setPopupAvatar(true)}
                            editable={editable} />
                    </div>
                    <div className={classes.item}>
                        <Typography variant="caption" display="block">
                            {t("label.character.avatar")}
                        </Typography>
                        <ButtonBase onClick={e => editable ? setPopup(true) : null}>
                            {
                            <Character 
                                sprite={spriteManager}
                                suspended={popup}
                                character={myInfo.avatar}
                                />
                            }
                        </ButtonBase>
                    </div>
                    <div className={classes.item}>
                        <StatusText
                            label={t("label.character.status")}
                            value={myInfo.status}
                            onChange={(v)=>setMyInfo({...myInfo, status: v})}
                            editable={editable}

                        />
                    </div>
                    <div className={classes.item}>
                        <RatingField
                            label={t("label.character.busyness")}
                            value={myInfo.busyness}
                            onChange={v=>setMyInfo({...myInfo, busyness: v})}
                            editable={editable}
                        />
                    </div>
                    <div className={classes.item}>
                        <OnelineText 
                            label={t("label.character.comment")}
                            value={myInfo.comment}
                            onChange={(v)=>{setMyInfo({...myInfo, comment:v})}}
                            editable={editable} />
                    </div>
                    <Divider />
                    <Modal
                        open={popup}
                        onClose={() => setPopup(false)}
                        
                    >
                        <PopupContent>
                            <CharacterCreate 
                                avatar={myInfo.avatar}
                                onSuccess={(avatar)=>{
                                    setPopup(false)
                                    setMyInfo({...myInfo, avatar: avatar})
                                }}
                            ></CharacterCreate>
                        </PopupContent>
                    </Modal>
                    <Modal
                        open={popupAvatar}
                        onClose={() => setPopupAvatar(false)}
                    >  
                        <PopupContent>
                            <AvatarUpload
                                onSuccess={(file, dataUri)=>{
                                    setPopupAvatar(false)
                                    setBlob(file)
                                    setMyInfo({...myInfo, icon: {...myInfo.icon, get: dataUri}})
                                }}
                            />
                        </PopupContent>
                    </Modal>
                </div>
            : null }
        </div>
    )
}

export default MyInfo;